/**
 * Generated by @openapi-codegen
 *
 * @version 0.0.0
 */
import * as reactQuery from 'react-query';
import { useOpenapiContext, OpenapiContext } from 'openapi/client/OpenapiContext';
import type * as Fetcher from 'openapi/client/OpenapiFetcher';
import { openapiFetch } from 'openapi/client/OpenapiFetcher';
import type * as Schemas from 'openapi/client/OpenapiSchemas';

export type ApiTrackLogNewRelicCreateError = Fetcher.ErrorWrapper<undefined>;

export type ApiTrackLogNewRelicCreateVariables = {
  body: Schemas.LogRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchApiTrackLogNewRelicCreate = (
  variables: ApiTrackLogNewRelicCreateVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<Schemas.Detail, ApiTrackLogNewRelicCreateError, Schemas.LogRequest, {}, {}, {}>({
    url: '/api/track/log_new_relic/',
    method: 'post',
    ...variables,
    signal,
  });

export const useApiTrackLogNewRelicCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Detail,
      ApiTrackLogNewRelicCreateError,
      ApiTrackLogNewRelicCreateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.Detail,
    ApiTrackLogNewRelicCreateError,
    ApiTrackLogNewRelicCreateVariables
  >({
    mutationFn: (variables: ApiTrackLogNewRelicCreateVariables) =>
      fetchApiTrackLogNewRelicCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type QueryOperation = {
  path: string;
  operationId: never;
  variables: unknown;
};
